import { Button } from "@/components/atoms/Buttons";
import { MyProfileSelectProps } from "@/pages/mypage/MyProfileSelectPage";
import * as S from "./Header.style";
import { ReactComponent as IconLogo } from "@/styles/assets/svg/logo_only.svg";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_left.svg";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  pageTitle?: string;
  setPopover?: any;
  selectedProfile?: MyProfileSelectProps;
  headerRight?: React.ReactNode;
  onBackHandler?: () => void;
}

export const Header = ({
  pageTitle,
  setPopover,
  selectedProfile,
  headerRight,
  onBackHandler,
}: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <>
      <S.Header>
        <S.HeaderLeftBox>
          {pageTitle ? (
            <Button
              type="button"
              size="sm"
              width="40px"
              layout="icon"
              color="gray100"
              icon={<IconArrow width={24} height={24} />}
              onClick={onBackHandler ? onBackHandler : () => navigate(-1)}
            />
          ) : (
            <IconLogo
              width={60}
              height={20}
              onClick={() => navigate("/", { replace: true })}
            />
          )}
        </S.HeaderLeftBox>
        <S.HeaderTitBox>{pageTitle && <h2>{pageTitle}</h2>}</S.HeaderTitBox>
        <S.HeaderRightBox>
          <S.AlarmButton type="button">{/* <IconAlarm /> */}</S.AlarmButton>
          {headerRight && headerRight}
          {/* <Button
            type="button"
            size="xsm"
            width="40px"
            layout="icon"
            color="gray100"
            icon={<IconSetting />}
          /> */}
          {/* <ButtonUserProfile
            onClick={() => setPopover(true)}
            selectedProfile={selectedProfile}
          /> */}
        </S.HeaderRightBox>
      </S.Header>
    </>
  );
};
